export const layoutResources = {
  'layout.header.accountDropdownTitle': 'Configuraciones de la cuenta',
  'layout.notifications.clearNotifications': 'Borrar notificaciones confirmadas',
  'layout.footer.copyright': 'Copyright Shipium',
};
export type LayoutResourceKey =
  | 'layout.header.accountDropdownTitle'
  | 'layout.notifications.clearNotifications'
  | 'layout.footer.copyright';
